module.exports = __webpack_public_path__ + "img/1535367971.fbba4e42.jpg";